import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AUTH_LOCAL_VARIABLES,
  clearAuth,
} from "../../store/features/authSlice";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ROUTES } from "../../routes";
import secureLocalStorage from "react-secure-storage";

export const AuthGuard = ({ children }) => {
  const currentUser = useSelector((s) => s.auth.currentUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      dispatch(clearAuth());
      toast("Please Login..", {
        theme: "colored",
        type: "error",
      });
      return navigate(ROUTES.LOGIN);
    }
  }, []);
  return <>{children}</>;
};
